<template>
	<div class="div-week">
    <div class="box-ttct">
      <div class="card-avtar">
          <div class="next_page_details">
            <img v-show="linkImage != null" :src="linkImage" alt="Load Image..." class="avt-dt" @click="nextPageDetails()" />
            <button class="btn-download-tt" @click="nextPageDetails()">{{$t('manage_lesson.next_page_details')}}</button>
            <!-- <template v-if="!mobile">
              <button v-if="checkListStudents" @click="downloadInfoCourse()" class="btn-details-course">{{$t('manage.downloadStudents')}}</button>
              <button v-else class="btn-details-course btn-details-course-not-list">{{$t('manage.downloadStudents')}}</button>
            </template> -->
            <!-- Download -->
            <!-- Waiting ticket -->
            <!-- <button class="btn-download-tt" @click="exportExcel">{{ $t("new.title294") }}
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                            <polyline points="7 10 12 15 17 10" />
                            <line x1="12" y1="15" x2="12" y2="3" />
                        </svg>
            </button> -->
            <template v-if="!mobile && courseExam">
                <button class="btn-download-tt rt" @click="download()">
                    {{$t('manage_student.export')}}
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="7 10 12 15 17 10" />
                        <line x1="12" y1="15" x2="12" y2="3" />
                    </svg>
                </button>
            </template>
          </div>
      </div>
      <div class="card-tt" >
        <div class="content_introduce" v-html="contentIntroduceCourse">
        </div>
        <div class="content_introduce">
            <label>{{$t('manage_lesson.time_course')}}: </label>
            <span>{{timeStart}} ~ {{timeEnd}}</span>
        </div>
        <div :class="[{tooltip: !mobile}, {uio9: !mobile &&  listTeacher != null ? listTeacher.length > maxLengtText : false }]">
          <span v-if="!mobile" class="tooltiptext">
            <span style="color:#00a8ff" v-if="checkNameUser">{{ checkNameUser }},</span>
            <span>{{listTeacher}}</span>
          </span>
          <div class="content_introduce lkt-hiddenText" style="-webkit-box-orient: vertical !important;" >
            <label>{{$t('manage_lesson.teacher_charge')}}: </label>
            <span style="color:#00a8ff" v-if="checkNameUser">{{ checkNameUser }},</span>
            <span style="word-break: break-all;" v-html="listTeacher"></span>
          </div>
        </div>
        <h4 class="h4-thongke">{{$t('profile.statistic')}}</h4>
        <div class="row_content_statistical_course">
            <label>{{$t('manage_lesson.total_student')}}</label>
            <span class="number_lesson">{{ totalStudensCourse }}</span>
        </div>
        <div class="row_content_statistical_course course_child">
            <label>{{$t('manage_lesson.status1')}}</label>
            <span class="number_lesson">{{ status1 }}</span>
        </div>
        <div class="row_content_statistical_course course_child">
            <label>{{$t('manage_lesson.status2')}}</label>
            <span class="number_lesson">{{ status2 }}</span>
        </div>
        <div class="row_content_statistical_course course_child">
            <label>{{$t('manage_lesson.status3')}}</label>
            <span class="number_lesson">{{ status3 }}</span>
        </div>
      </div>
    </div>
    <loading class="loading--lesson" :showLoading="!isLoadData" />
	</div>
</template>

<script>
  import Vue from 'vue'
  import { mapState, mapMutations } from "vuex";
  import {lang} from '../../assets/languages/getLanguageType.js';
  import loading from "@/components/loading/loading";
  Vue.prototype.$lang = lang;
	export default {
		props: {
      data: {
        type:Object,
        default: {}
      }
    },
		data() {
			return {
        courseExam: false,
				dataResponse: [],
        cns: [],
        nqtLearnPercent: this.$CONST.MENU.MIN_PERCENT,
        isLoadData: false,
        userId: null,
				courseName: null,
        activeMenu: null,
        totalLesson: 0,
        totalExercise: 0,
        totalStudensCourse: 0,
        timeStart: "",
        timeEnd: "",
        listTeacher: "",
        statusCourse: "",
        contentIntroduceCourse: "",
        linkImage: null,
        status1: 0,
        status2: 0,
        status3: 0,
        checkLoad: false,
        checkNameUser: "",
        maxLengtText: 20,
        checkListStudents: false,
        todayManageCourse: "",
			}
		},
    components: {
      loading,
    },
    computed: {
      // Lấy dữ liệu từ store
      ...mapState({
          mobile: (state) => state.header.mobile
      }),
    },
    async mounted () {
      let today = new Date();
      let istoday = today.toISOString().split('T')[0];
      this.todayManageCourse = istoday.replaceAll('-', '');
      this.totalStudensCourse = this.data.purchaseDetails.totalStudent;
      if (this.data.purchaseDetails.totalStudent>0) {
        this.checkListStudents = true;
      }
      this.status1 = this.data.purchaseDetails.totalUndone;
      this.status2 = this.data.purchaseDetails.totalDoing;
      this.status3 = this.data.purchaseDetails.totalDone;
      if (!this.data.courseId) return;
      this.getInforCourse(this.data.purchaseDetails);
      this.courseExam = await this.getCourseCategory(this.data.courseId);
    },
		methods: {
      downloadInfoCourse: function(){
        let tempList = [];
        this.data.list.forEach(value => {
          let itemListData = {};
          itemListData.userName = value.userName;
          itemListData.email = value.email;
          itemListData.sex = " ";
          if (value.sex==1) {
            itemListData.sex = this.$t("manage_student.male");
          } else if (value.sex==2) {
            itemListData.sex = this.$t("manage_student.female");
          }
          itemListData.startStudyDate = " ";
          if (value.startStudyDate) {
            itemListData.startStudyDate = value.startStudyDate;
          }
          itemListData.endStudyDate = " ";
          if (value.endStudyDate) {
            itemListData.endStudyDate = value.endStudyDate;
          }
          itemListData.status = "";
          if (value.startStudyDate!=null&&value.endStudyDate!=null || value.startStudyDate==null&&value.endStudyDate!=null) {
            itemListData.status = this.$t("statictical.completed");
          } else if (value.startStudyDate==null&&value.endStudyDate==null) {
            itemListData.status = this.$t("statictical.unstudied");
          } else {
            itemListData.status = this.$t("statictical.studying");
          }
          tempList.push(itemListData);
        });
        var headerName = [
                {
                    key: "userName",
                    value: "new.title51"
                },
                {
                    key: "email",
                    value: "profile.email"
                },
                {
                    key: "sex",
                    value: "manage.sex"
                },
                {
                    key: "status",
                    value: "manage_student.status"
                },
                {
                    key: "startStudyDate",
                    value: "new.title60"
                },
                {
                    key: "endStudyDate",
                    value: "new.title61"
                }
            ]
            var params = {
                header: true,
                titles: ["userName", "email", "sex", "status", "startStudyDate", "endStudyDate"],
                data: tempList,
                headerName: headerName,
                name: this.data.nameCourse + this.todayManageCourse + ".csv"
            }
            this.exportCsv(params);
      },
      getInforCourse: function(data){
        this.isLoadData = true;
        this.timeStart = data.startDate;
        this.timeEnd = data.endDate;
        this.contentIntroduceCourse = data.synopsis;
        if(data.courseCover){
          this.linkImage = data.courseCover;
        } else {
          this.linkImage = "../../../static/images/temppic.jpg";
        }
        
        let arrayTeacher = [];
        if (data.teacherList) {
          data.teacherList.forEach(function(item) {
              if(arrayTeacher.indexOf(item.userName) < 0) {
                  arrayTeacher.push(item.userName);
              }
          });
          arrayTeacher.forEach((el, index) => {
            if(el==window.sessionStorage.getItem("name")){
              this.checkNameUser = el;
              arrayTeacher.splice(index, 1);
            }
          });
          this.listTeacher = arrayTeacher.toString().replaceAll(',', ', ');
        }
      },
      nextPageDetails(){
        window.sessionStorage.setItem("historyManageLesson", this.$route.fullPath);
        this.$router.push({
          name: "Aicourse",
          query: {
            buyCourseId: this.data.courseId,
            buyCollegeId: 1,
          },
        });
      },
      formats(learnPercent) {
        if (document.getElementsByClassName("el-progress-bar__innerText")[0] != null) {
          document.getElementsByClassName("el-progress-bar__innerText")[0].innerText = learnPercent + '%';
        }
      },
      toggleClass(event, parentID) {
        event.target.classList.toggle("caret-down");
        event.target.nextElementSibling.classList.toggle("active");
        // this.activeMenu = parentID;
      },
      jumpTaskResult: function (item1, item2, item3, item4, item5, oop) {
        if (oop.isBuy != this.$CONST.MENU.IS_TITLE) return;
        for (let i = 0; i < this.data.list.length; i++) {
          const element = this.data.list[i];
          if(element.courseId == this.data.courseId) {
            this.courseName = element.courseName;
          }
        }
        let outlineInfo = {
          "topId": item1.id != undefined ? item1.id : null,
          "secondId": item2.id != undefined ? item2.id : null,
          "secondChapterName": oop.chapterName,
          "thirdId": item3.id != undefined ? item3.id : null,
          "fourthId": item4.id != undefined ? item4.id : null,
          "fifthId": item5.id != undefined ? item5.id : null,
          "type": this.$CONST.MENU.TYPE,
          "courseId": oop.courseId,
          "courseName": this.courseName,
          "courseOutlineId":oop.id
        };
        this.$router.push({
          path: "students/task/result",
          query: {
            outlineInfo: JSON.stringify(outlineInfo),
            studentId: this.data.studentId
          }
        });
      },

      // NQT

      ...mapMutations("manageStudent", ["setLoadingLesson"]),

      // format date
      appendLeadingZeroes: function (n) {
          if (n <= 9) {
              return "0" + n;
          }
          return n;
      },

      // Xuất thành tích học viên
      download: function () {
          const self = this;

          let currentDatetime = new Date();
          let today = currentDatetime.getFullYear() + "/" + this.appendLeadingZeroes(currentDatetime.getMonth() + 1) + "/" + this.appendLeadingZeroes(currentDatetime.getDate());
          let fileName = this.data.purchaseDetails.courseName + "_" + today + ".csv";

          this.setLoadingLesson(true);

          let listAttence = this.data.purchaseDetails.studentList.filter(item => parseInt(item.examStatus) != 0 && parseInt(item.examStatus) != -1);

          Promise.all(listAttence.map(item => {
              return self.getsingleCourseScoreStatistics(item);
          })).then(function(results) {
              
              let statistics = results.filter(item => item.statistics.length > 0);

              const listS = statistics.reduce((a, v) => {
                  a = a.concat(v.statistics);
                  return a;
              }, []);

              Promise.all(listS.map(item => {
                  return self.getExamRecord(item);
              })).then(function(results2) {
                  let examList = results2.filter(item => item.examList.length > 0);
                  const listE = examList.reduce((accumulator, value) => {
                      accumulator = accumulator.concat(value.examList);
                      return accumulator;
                  }, []);

                  const csvPrev = listE.reduce((accumulator, value) => {

                      let passMark = parseFloat(value.res) ? parseFloat(value.res) : 0;
                      let score = parseFloat(value.score) ? parseFloat(value.score) : 0;
                      let status = score >= passMark ? self.$t("scoreStatistics.point90") : self.$t("scoreStatistics.point80");                  

                      value.courseName = value.courseName != null ? value.courseName.replace(/,/g, " |") : value.courseName;                   
                      value.deptNames = value.deptNames != null ? value.deptNames.replace(/,/g, " |") : value.deptNames;                   
                      value.examName = value.examType == 2 ? value.examName : self.$t("scoreStatistics.finalExam");
                      value.timeExamStart = value.timeExamStart != null ? value.timeExamStart : "ー";
                      value.timeExamEnd = value.timeExamEnd != null ? value.timeExamEnd : "ー";
                      value.timeExamConduct = parseInt(value.timeExamConduct) ? parseFloat(value.timeExamConduct) : 0;
                      value.fullMarks = parseFloat(value.fullMarks) ? parseFloat(value.fullMarks) : 0;
                      value['passMarks'] = parseFloat(value.res) ? parseFloat(value.res) : 0;
                      value['score'] = parseFloat(value.score) ? parseFloat(value.score) : 0;
                      value['status'] = status;
                      
                      accumulator.push(value);
                      return accumulator;
                  }, []);

                  const csv = csvPrev.filter(item => item.examName != null);

                  // Export
                  // Khai báo header CSV
                  var headerName = [
                      {
                          key: "studentName",
                          value: "profile.name",
                      },
                      {
                          key: "deptNames",
                          value: "manage_student.chi_nhanh",
                      },
                      {
                          key: "courseName",
                          value: "home.courseName",
                      },
                      {
                          key: "examName",
                          value: "scoreStatistics.testName",
                      },
                      {
                          key: "fullMarks",
                          value: "new.title24",
                      },
                      {
                          key: "passMarks",
                          value: "scoreStatistics.passPercent",
                      },
                      {
                          key: "score",
                          value: "examResume.point",
                      },
                      {
                          key: "status",
                          value: "scoreStatistics.judge",
                      },
                      {
                          key: "timeExamStart",
                          value: "scoreStaticNew.timeExamStart",
                      },
                      {
                          key: "timeExamEnd",
                          value: "scoreStaticNew.timeExamEnd",
                      },
                      {
                          key: "timeExamConduct",
                          value: "scoreStaticNew.timeExamConducted",
                      }
                  ];
                  var params = {
                      header: true,
                      titles: ["studentName", "deptNames", "courseName", "examName", "timeExamConduct", "timeExamStart", "timeExamEnd", "fullMarks", "passMarks", "score", "status"],
                      data: csv,
                      headerName: headerName,
                      name: fileName
                  };

                  // Download
                  self.setLoadingLesson(false);
                  if (csv.length) {
                      self.exportCsv(params);
                  } else {
                      self.$confirm(this.$i18n.t("new.title113"),
                          this.$i18n.t("new.title86"),
                          {cancelButtonClass: "btn-nqt---show"}
                      ).then(() => {}).catch(() => {});
                  }
              })
          })
      },

      // Lấy lịch sử thi của học viên theo từng khóa
      getExamRecord: function (item) {
          const self = this;
          let courseId = item.examId == null ? item.courseId : null;
          return new Promise((resolve, reject) => {
              this.$api
                  .post("/home/getExamRecord", {
                      courseId: courseId,
                      examId: item.examId,
                      languageType: this.$lang(),
                      userId: item.userId
                  })
                  .then((response) => {
                      const result = response.data.list.reduce((a, v) => {
                          v['courseId'] = self.data.courseId;
                          v['deptNames'] = item.deptNames;
                          v['studentName'] = item.studentName;
                          a.push(v);
                          return a;
                      }, []);
                      item['examList'] = result;
                      resolve(item);
                  })
                  .catch((err) => {
                      reject(err.response);
                  });
          });
      },

      // Get examID
      getsingleCourseScoreStatistics: function (item) {
          const self = this;
          return new Promise((resolve, reject) => {
              this.$api
                  .post("/home/getsingleCourseScoreStatistics", {
                      courseId: this.data.courseId,
                      languageType: this.$lang(),
                      userId: item.id
                  })
                  .then((response) => {
                      const listS = response.data.reduce((a, v) => {
                          let obj = {
                              examId: v.examId,
                              courseId: self.data.courseId,
                              userId: item.id,
                              deptNames: item.deptNames,
                              studentName: item.userName
                          }
                          a.push(obj);
                          return a;
                      }, []);
                      item['statistics'] = listS;
                      resolve(item);
                  })
                  .catch((err) => {
                      reject(err.response);
                  });
          });
      },

      // Lấy điểm đậu
      getPastExamInfo: function (item) {
          let courseId = item.examId == null ? item.courseId : null;
          return new Promise((resolve, reject) => {
              this.$api
                  .post("/studyCourseQuestion/getPastExamInfo", {
                      courseId: courseId,
                      examId: item.examId,
                  })
                  .then((response) => {
                      let passMarks = response.data.passMarks;
                      let status = Number(item.score) >= Number(passMarks) ? this.$t("scoreStatistics.point90") : this.$t("scoreStatistics.point80");
                      item['passMarks'] = passMarks;
                      item['status'] = status;
                      item['courseName'] = item.courseName.replace(/,/g, ' |');
                      resolve(item);
                  })
                  .catch((err) => {
                      reject(err.response);
                  });
          });
      },

      // Lấy thông tin loại khóa học
      getCourseCategory: function (courseId) {
          return new Promise((resolve, reject) => {
              this.$api
                  .post("/courseStudy/getCourseCategory", {
                      courseId: courseId,
                  })
                  .then((response) => {
                      let data = [1, 2, 3, 4, 9, 10, 11, 12];
                      let key = data.findIndex(x => x == parseInt(response.data.courseCategoryCode));
                      let status = false;
                      if (key >= 0) {
                        status = true;
                      }
                      resolve(status);
                  })
                  .catch((err) => {
                      reject(err.response);
                  });
          });
      },
      // checkSt: function (sts) {
      //           if (sts == 1) {
      //               return this.$t("studySituationList.raised")
      //           }

      //           if (sts == 0) {
      //               return this.$t("studySituationList.notRaised")
      //           }

      //           return "ー";
      // },
      // exportExcel: function () {
      //           this.$api
      //           .post("/courseTrainee/getData"
      //           , {
      //             courseId: this.data.courseId,
      //             language: this.$lang(),
      //             // pageQuery: {
      //             //   pageNum: that.pageNum,
      //             //   pageSize: that.pageSize,
      //             // },
      //           })
      //           .then((response) => {
      //             let dt = response.data.courseTraineeList.list;
      //             const self = this;
      //             var csv = [];
      //             dt.forEach((item) => {
      //                 let examName = '--';

      //                 if (item.examName == null && item.userScore != null) {
      //                     examName = self.$t("scoreStatistics.finalExam");
      //                 } else if (item.examName != null && item.userScore != null) {
      //                     examName = item.examName;
      //                 } else {
      //                     examName = "―";
      //                 }
      //                 if (item.deptName==null) {
      //                     item.deptName = "_";
      //                 } else {
      //                     item.deptName = item.deptName.replace(/,/g, " |");
      //                 }
      //                 let obj = {
      //                     name: item.name,
      //                     deptName: item.deptName,
      //                     schedule: item.schedule,
      //                     testName: examName,
      //                     isPassFlag: item.isPassFlag != null && item.isPassFlag != "-" && item.isPassFlag != "―" ? item.isPassFlag : "―",
      //                     timeExamStart: item.timeExamStart != null ? item.timeExamStart : "―",
      //                     timeExamEnd: item.timeExamEnd != null ? item.timeExamEnd : "―",
      //                     timeExamConduct: item.timeExamConduct != null ? item.timeExamConduct : "―",
      //                     dateStart : item.dateStart != null && item.dateStart != "" ? item.dateStart : "―",
      //                     dateEnd : item.dateEnd != null && item.dateEnd != "" ? item.dateEnd : "―",
      //                     sum : item.sum != null ? item.sum : "―",
      //                     exitDate : item.exitDate != null ? item.exitDate : "―",
      //                     userScore : item.userScore != null ? item.userScore : "―",
      //                     total : item.total != null ? item.total : "―",
      //                     isGuarantee : self.checkSt(item.isGuarantee),
      //                     isQuestionnaire : self.checkSt(item.isQuestionnaire),
      //                     isFinished : self.checkSt(item.isFinished)
      //                 }
      //                 csv.push(obj);
      //             });
      //             if (csv.length==0) {
      //                 this.$confirm(window.vm.$i18n.t("new.title185"), window.vm.$i18n.t("new.title86"), { cancelButtonClass: "btn-nqt---show" })
      //                 .then(() => {})
      //                 return;
      //             }
      //             // Khai báo header CSV
      //             var headerName = [
      //                 {
      //                     key: "name",
      //                     value: "new.title51",
      //                 },
      //                 {
      //                     key: "deptName",
      //                     value: "new.title54_1",
      //                 },
      //                 {
      //                     key: "schedule",
      //                     value: "new.title57",
      //                 },
      //                 {
      //                     key: "testName",
      //                     value: "scoreStatistics.testName",
      //                 },
      //                 {
      //                     key: "userScore",
      //                     value: "new.title58",
      //                 },
      //                 {
      //                     key: "isPassFlag",
      //                     value: "scoreStatistics.judge",
      //                 },
      //                 {
      //                     key: "timeExamStart",
      //                     value: "scoreStaticNew.timeExamStart",
      //                 },
      //                 {
      //                     key: "timeExamEnd",
      //                     value: "scoreStaticNew.timeExamEnd",
      //                 },
      //                 {
      //                     key: "timeExamConduct",
      //                     value: "scoreStaticNew.timeExamConducted",
      //                 },
      //                 {
      //                     key: "dateStart",
      //                     value: "new.title60",
      //                 },
      //                 {
      //                     key: "dateEnd",
      //                     value: "new.title61",
      //                 },
      //                 {
      //                     key: "sum",
      //                     value: "new.title62",
      //                 },
      //                 {
      //                     key: "total",
      //                     value: "new.title63",
      //                 },
      //                 {
      //                     key: "isGuarantee",
      //                     value: "new.title64",
      //                 },
      //                 {
      //                     key: "isQuestionnaire",
      //                     value: "new.title65",
      //                 },
      //                 {
      //                     key: "exitDate",
      //                     value: "new.title55",
      //                 },
      //                 {
      //                     key: "isFinished",
      //                     value: "new.title66",
      //                 }
      //             ];
      //             var params = {
      //                 header: true,
      //                 titles: ['name', 'deptName', 'schedule', 'testName', 'userScore', 'isPassFlag', 'timeExamStart', 'timeExamEnd', 'timeExamConduct', 'dateStart', 'dateEnd', 'sum', 'total', 'isGuarantee', 'isQuestionnaire', 'exitDate', 'isFinished'],
      //                 data: csv,
      //                 headerName: headerName,
      //             };

      //             // Download
      //             this.exportCsv(params);
      //                             });
                
      //       },
		}
	}
</script>
<style scoped>
  .btn-download-tt {
    height: 40px;
    border: 2px solid #0071c5;
    background-color: #ffffff;
    color: black;
    font-size: 12px;
    font-weight: bold;
    border-radius: 5px;
    margin-top: 5px;
    margin-bottom: 0;
    transition: ease 0.5s;
    width: 200px;
    position: relative;
  }
  .btn-download-tt.rt {
    padding-right: 35px;
  }
  .btn-download-tt svg {
    width: 32px;
    height: 32px;
    position: absolute;
    top: 0;
  }
 .card-avtar{
   width: 200px;
 }
 .card-tt{
   width: calc(100% - 200px);
 }
 .lkt-hiddenText{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis!important;
 }
 .tb-week img {
      cursor: unset;
  }
  .noTitle span {
      cursor: unset;
  }
  .noTitle span:hover {
      color: black;
  }
  .dot.dot--studing{
    background: #da251d;
  }
  .nqtLearnPercent {
    margin-bottom: 15px;
  }
  .parent-ul-ol {
    margin-bottom: 0;
    text-transform: none;
    color: #000000;
    font-size: 14px;
    font-weight: normal;
  }
  span.caret.caret-down {
    text-transform: none;
    color: #000000;
  }
  .parent-ul {
    font-size: 14px;
  }
  .nqt-mobie {
    display: none;
  }
  @media (max-width: 834px) {
    .nqt-mobie {
      display: block;
    }
  }
  .done_score a{
    background: #118e07;
  }
  .div-week{
    margin-top: 20px;
  }
  .statistical_course{
    margin-top: 20px;
  }
  h2 {
    color: #0071c5;
  }
  .content_statistical_course{
    padding: 0 25px;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
  }
  .row_content_statistical_course {
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #ECEEF5;
  }
  .row_content_statistical_course label {
    font-size: 14px;
    font-weight: bold;
    width: 190px;
  }
  .header_list_lesson {
    margin-top: 20px;
  }
  .content_introduce {
    font-size: 14px;
    padding-bottom: 10px;
  }
  .avt-dt {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .btn-details-course {
    margin-top: 10px;
    padding: 10px;
    background-color: #0071c5;
    color: #fff;
    border: 0;
    border-radius: 10px;
    font-weight: bold;
    width: 200px;
  }
  .btn-details-course:hover{
    background:#2696ff;
  }
  .row_content_statistical_course label{
    width: 300px!important;
  }
  .h4-thongke {
    background: #00b5ad;
  }
  @media (max-width: 320px) {
    .row_content_statistical_course label{
    width: 260px!important;
  }
}
  .next_page_details{
    display: contents;
  }
  .number_lesson {
    font-size: 14px;
  }
  /* Tooltip text */
.tooltip .tooltiptext {
  margin-top: 22px;
  visibility: hidden;
  width: 420px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px;
  border-radius: 6px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
  /* top: 36px; */
  left: 43%;  
}


.tooltip .tooltiptext::after {
  content: " ";
  position: absolute;
  bottom: 100%; 
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent black transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.uio9:hover .tooltiptext {
  visibility: visible;
}
.uio9 {
  -webkit-box-orient: vertical !important;
  cursor: pointer;
}
.uinqt {
  height: 54px;
}
.btn-details-course-not-list{
  background: #d2d2d2 !important;
  cursor: no-drop;
}
</style>




// WEBPACK FOOTER //
// src/components/manage/detailCourseInManagerCourse.vue